export default __webpack_public_path__ + "static/media/GaugeImg3.1d21c20a.jpg";